

import { useState } from "react";
import { iconos } from "../../../data";
import { Card, Tabs, Tab, Grid, alpha, useMediaQuery, Box } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';


const StyledCard = styled(Card)(({ theme }) => ({
    width:'100%',
    flex:1,
    height:'100%',
    borderRadius: theme.spacing(2),
    overflow:'hidden',
    display: 'flex',          
    flexDirection: 'column',
}));


const StyledTabs = styled(Tabs)(({ theme }) => ({
    borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
    '& .MuiTabs-indicator': {
        height: 3,
        borderRadius: '3px 3px 0 0',
        boxShadow: `0 0 8px ${alpha(theme.palette.primary.main, 0.3)}`,
    },
    '& .MuiTabs-flexContainer': {
        height: '100%', 
    },
}));

const StyledTab = styled(Tab)(({ theme }) => ({
    minHeight: 55,
    textTransform: 'none',
    fontWeight: 700,
    color:'#757575',
    fontSize: '0.95rem',
    padding: theme.spacing(1.5, 2),
    margin: theme.spacing(0, 0.5),
    borderRadius: `${theme.spacing(1)} ${theme.spacing(1)} 0 0`,
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    position: 'relative',
    overflow: 'hidden',
    
    '&:hover': {
        transform: 'translateY(-2px)',
        '&::before': {
        opacity: 1,
        },
    },
    
    '&.Mui-selected': {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.primary.main,
        fontWeight: 600,
        boxShadow: `0 -2px 12px ${alpha(theme.palette.primary.main, 0.15)}`,
        
        '& .MuiSvgIcon-root': {
        transform: 'scale(1.1)',
        filter: `drop-shadow(0 0 4px ${alpha(theme.palette.primary.main, 0.3)})`,
        },
    },
    
    '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: `linear-gradient(45deg, ${alpha(theme.palette.primary.main, 0.05)}, ${alpha(theme.palette.secondary.main, 0.05)})`,
        opacity: 0,
        transition: 'opacity 0.3s ease',
        zIndex: -1,
    },
    
    '& .MuiSvgIcon-root': {
        transition: 'all 0.3s ease',
        marginRight: theme.spacing(1),
    },
}));



export const TabsDinamicosTodo = ({ tabs, setTabIndex }) => {

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [vistaActiva, setVistaActiva] = useState(tabs[0]?.value || "");


    const  handleOnChange = (val) => {
        setVistaActiva(val);
        if (typeof setTabIndex === "function") setTabIndex(val);
    }

    

    return (

        <StyledCard>
            <StyledTabs
                value={vistaActiva}
                onChange={(_, val) => handleOnChange(val)}
                indicatorColor="primary"
                textColor="primary"
                // variant={isSmallScreen ? "scrollable" : "fullWidth"}
                variant={isSmallScreen && tabs.length > 1 ? "scrollable" : "fullWidth"}
                scrollButtons="auto"
                allowScrollButtonsMobile 
            >
                {tabs.map((tab) => (
                <StyledTab
                    key={tab.value}
                    label={tab.label}
                    value={tab.value}
                    icon={iconos[tab.icono]}
                    iconPosition="start"
                />
                ))}
            </StyledTabs>

            <Grid sx={{height:'100%', flex:1, p:1.5 }}>
                {tabs.map((tab) => (
                    tab.value === vistaActiva && (
                        <Box key={tab.value} sx={{display: 'flex', flexDirection: 'column', height:'100%'}}> 
                            { tab.component } 
                        </Box>
                    )
                ))}
            </Grid>
        </StyledCard>
    )
}



